import styled from "styled-components/macro";

import UserDonorSummaries from "CrossFeatureComponents/UserDonorSummaries";
import { useManageMyGivingPage } from "Giving/ManageMyGivingPage/ManageMyGivingPageContext";

import FnrIcon, { FnrIconWrapper } from "UI/FnrIcon";

export default function DonorSummariesScreen() {
  const { state } = useManageMyGivingPage();

  const householdID = state.userGivingData?.householdID;
  const reports = state.userGivingData?.taxReports || [];

  if (reports.length === 0) return null;

  return (
    <Container className="donor_summaries_container">
      <Wrapper>
        <TitleBar>
          <TitleText>
            <FnrIcon fad fa-copy />
            My Documents
          </TitleText>
        </TitleBar>

        <UserDonorSummaries
          householdID={householdID}
          reports={reports}
          style={{ padding: "14px 4px 20px 20px", maxHeight: 320 }}
        />
      </Wrapper>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-grow: 0;
  flex-shrink: 0;
  max-width: 292px;
  grid-area: summaries;
  align-self: start;
  @media (max-width: 1000px) {
    max-width: none;
    display: block;
  }
`;

const Wrapper = styled.div`
  position: relative;

  background: linear-gradient(
    140deg,
    var(--bgGradient1) 0%,
    var(--bgGradient2) 100%
  );
  border-radius: 24px;
  margin-bottom: 40px;
`;
const TitleBar = styled.div`
  padding-left: 20px;
  padding-right: 18px;
  padding-top: 14px;
  margin-bottom: 8px;
  display: flex;
`;
const TitleText = styled.div`
  font-size: 18px;
  gap: 6px;
  display: flex;
  align-items: center;
  position: relative;
  padding: 0 1px;
  & ${FnrIconWrapper} {
    font-size: 20px;
  }
  &::after {
    content: "";
    display: block;
    background: #fff;
    height: 4px;
    left: 0;
    right: 0;
    position: absolute;
    top: 100%;
    margin-top: 3px;
    border-radius: 5px;
  }
`;
